import Route from 'mewe/routes/route';

export default class Web3LoginRoute extends Route {}
